<div class="win-back-config" *ngIf="winBackForm" [formGroup]="winBackForm!">
  <div class="field">
    <label class="field__label">Inactive For</label>
    <p-selectButton
      [options]="inactivityPeriodOptions"
      formControlName="InactivityPeriod"
      optionLabel="label"
      optionValue="value"
    ></p-selectButton>
    <small class="field__hint">
      Targets consumers who purchased before but have not made a transaction in the selected period.
    </small>
    <small
      class="p-error"
      *ngIf="winBackForm!.controls.InactivityPeriod.invalid && winBackForm!.controls.InactivityPeriod.dirty"
    >
      Select an inactivity period to preview and save this audience.
    </small>
  </div>
</div>
